var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contact-page"},[_vm._m(0),_c('ContactsUs')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detail-banner"},[_c('div',{staticClass:"container"},[_c('h1',[_vm._v("Contact Us")]),_c('p',{staticClass:"pd-banner-sub"},[_vm._v("Share your brief. We'll architect your entry.")])])])
}]

export { render, staticRenderFns }